import React, { useState } from 'react';
import SubmitAnswerButton from './submitanswersbutton';

const SentenceBuildTest = ({ questionNumber, onNext, isLastQuestion, getTotalExamVideoDuration, questionData, candidateTestId, timeRemaining, getVideoDuration, isLastQuestionOfSection,currentSection,sectionQuestions}) => {
  
  const transformQuestionData = (data) => {
    if (!data) return { words: [], correct: '' };
    
    
    if (data.words && data.correctOrder) {
      return {
        words: data.words,
        correct: data.correctOrder.join(' ')
      };
    }
    
   
    if (data.options && data.options.length > 0) {
      const words = data.options.map(opt => opt.optionText);
      const sortedOptions = [...data.options].sort((a, b) => a.orderNumber - b.orderNumber);
      const correctOrder = sortedOptions.map(opt => opt.optionText);
      
      return {
        words: words,
        correct: correctOrder.join(' ')
      };
    }
    
    return { words: [], correct: '' };
  };
  
  const currentSentence = transformQuestionData(questionData);
  
  const [availableWords, setAvailableWords] = useState([...currentSentence.words].sort(() => Math.random() - 0.5));
  const [selectedWords, setSelectedWords] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleWordClick = (word, fromAvailable = true) => {
    if (isSubmitted) return;

    if (fromAvailable) {
      setSelectedWords([...selectedWords, word]);
      setAvailableWords(availableWords.filter(w => w !== word));
    } else {
      setAvailableWords([...availableWords, word]);
      setSelectedWords(selectedWords.filter(w => w !== word));
    }
  };

  const handleClear = () => {
    if (isSubmitted) return;
    setAvailableWords([...availableWords, ...selectedWords]);
    setSelectedWords([]);
  };

  return (
    <div className="test-type-container">
      <div className="step-question">
        <h3 className="question-title">Arrange the words to form a correct sentence:</h3>
      </div>

      <div className="sentence-build-area">
        <div className="available-words-area">
          <label className="area-label">Available Words:</label>
          <div className="words-container available-container">
            {availableWords.map((word, index) => (
              <button
                key={`available-${index}`}
                className="word-btn available"
                onClick={() => handleWordClick(word, true)}
                disabled={isSubmitted}
              >
                {word}
              </button>
            ))}
          </div>
        </div>
        <div className="selected-words-area">
          <label className="area-label">Your Sentence:</label>
          <div className="words-container sentence-container">
            {selectedWords.length === 0 ? (
              <span className="placeholder-text">Click words below to build your sentence</span>
            ) : (
              selectedWords.map((word, index) => (
                <button
                  key={`selected-${index}`}
                  className="word-btn selected"
                  onClick={() => handleWordClick(word, false)}
                  disabled={isSubmitted}
                >
                  {word}
                </button>
              ))
            )}
          </div>
          {selectedWords.length > 0 && !isSubmitted && (
            <button 
              className="btn-clear" 
              onClick={handleClear}
            >
              Clear All
            </button>
          )}
        </div>
      </div>

      <div className="action-buttons">
        <SubmitAnswerButton
          questionNumber={questionNumber}
          questionData={questionData}
          candidateTestId={candidateTestId}
          isLastQuestion={isLastQuestion}
          isLastQuestionOfSection={isLastQuestionOfSection} 
          onNext={onNext}
          selectedSequence={selectedWords}
          testType="sentence-build"
          hasRecorded={true}
          timeRemaining={timeRemaining}
          // disabled={selectedWords.length !== currentSentence.words.length}
          getTotalExamVideoDuration={getTotalExamVideoDuration}
          getVideoDuration={getVideoDuration}
          section={currentSection}
          sectionQuestions={sectionQuestions}
        />
      </div>
    </div>
  );
};

export default SentenceBuildTest;
